module.exports = __webpack_public_path__ + "static/Simpsons-599c4e5078038ca9cd7a1adcc20914c0.jpg";